import React from 'react';
import type { FC, ReactNode } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import type { StripeElementsOptions } from '@stripe/stripe-js';

import { STRIPE } from '@portal/config/stripe';

const OPTIONS: StripeElementsOptions = {
  fonts: [
    {
      family: 'Basier Square',
      src: 'url(https://fonts.clutter.com/basiersquare-regular.woff)',
      style: 'normal',
    },
  ],
};

export const StyledStripeElements: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <Elements stripe={STRIPE} options={OPTIONS}>
    {children}
  </Elements>
);
